import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-89372f4a")

_pushScopeId("data-v-89372f4a")
const _hoisted_1 = { class: "remark" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "resize-handler",
      onMousedown: _cache[1] || (_cache[1] = $event => _ctx.resize($event))
    }, null, 32),
    _createVNode("textarea", {
      value: _ctx.remark,
      placeholder: "点击输入演讲者备注",
      onInput: _cache[2] || (_cache[2] = $event => _ctx.handleInput($event))
    }, null, 40, ["value"])
  ]))
})